'use strict';

window.renderCloudinaryGalleryWidget = function () {
    let imgUrls;
    const cldElements = document.getElementsByClassName('cloudinary-data-container');

    for (const el of cldElements) {
        const cloudinaryObj = typeof el.dataset.cloudinary === "string" && el.dataset.cloudinary.trim().startsWith("{")
            ? JSON.parse(el.dataset.cloudinary)
            : el.dataset.cloudinary;

        if (cloudinaryObj) {
            if (cloudinaryObj.galleryEnabled && typeof cloudinary !== 'undefined') {
                let galleryOptions = cloudinaryObj.images.galleryWidget.options;
                if (cloudinaryObj.domain !== 'res.cloudinary.com') {
                    galleryOptions.SecureDistribution = cloudinaryObj.domain;
                    galleryOptions.privateCdn = true;
                }
                window.cldGallery = window.cldProductGallery
                    ? window.cldProductGallery.galleryWidget(galleryOptions)
                    : (cloudinary.galleryWidget && cloudinary.galleryWidget(galleryOptions));

                if (window.cldGallery) {
                    window.cldGallery.render().then(function () {
                        // If gallery API looks valid, keep it
                        if ('getActiveIndex' in window.cldGallery) return;

                        // Otherwise, clean up and show default
                        if (typeof window.cldGallery.destroy === 'function') {
                            window.cldGallery.destroy();
                        }

                        var container =
                            (galleryOptions && galleryOptions.container && document.querySelector(galleryOptions.container)) ||
                            document.getElementById('cld-gallery');

                        if (container) {
                            container.innerHTML = '<img src="https://assets.sharkninja.com/image/upload/v1756717973/SharkNinja-NA/fallback_k99uoa.png" alt="Shark Ninja Image Coming Soon" style="max-width:100%; height:auto; display:block;">';
                        }

                    });
                }

            } else if (cloudinaryObj.images && cloudinaryObj.images.imageURLs) {
                imgUrls = cloudinaryObj.images.imageURLs;
            }
        }
    };

    return imgUrls;
};

window.renderCloudinarySetGalleryWidgets = function () {
    const dataContainer = document.getElementsByClassName('cloudinary-set-data-container')
    for (const el of dataContainer) {
        let cldObj = el.dataset.cloudinary && el.dataset.cloudinary.trim().startsWith("{") ? JSON.parse(el.dataset.cloudinary) : el.dataset.cloudinary;
        let cldSetImages = el.dataset.cloudinarySetImages && el.dataset.cloudinarySetImages.trim().startsWith("{") ? JSON.parse(el.dataset.cloudinarySetImages) : el.dataset.cloudinarySetImages;

        if (cldObj && cldObj.isEnabled && cldSetImages && cldSetImages.galleryWidget &&
            cldObj.galleryEnabled && typeof cloudinary !== 'undefined') {
            if (cldObj.domain !== 'res.cloudinary.com') {
                cldSetImages.galleryWidget.options.SecureDistribution = cldObj.domain;
                cldSetImages.galleryWidget.options.privateCdn = true;
            }
            window.cldGallery = window.cldProductGallery
                ? window.cldProductGallery.galleryWidget(cldSetImages.galleryWidget.options)
                : (cloudinary.galleryWidget && cloudinary.galleryWidget(cldSetImages.galleryWidget.options));

            if (window.cldGallery) {
                window.cldGallery.render().then(function () {
                    if ('getActiveIndex' in window.cldGallery) return;

                    if (typeof window.cldGallery.destroy === 'function') {
                        window.cldGallery.destroy();
                    }

                    var setOptions = cldSetImages.galleryWidget && cldSetImages.galleryWidget.options;
                    var container =
                        (setOptions && setOptions.container && document.querySelector(setOptions.container)) ||
                        document.getElementById('cld-gallery');

                    if (container) {
                        container.innerHTML = '<img src="https://assets.sharkninja.com/image/upload/v1756717973/SharkNinja-NA/fallback_k99uoa.png" alt="Test Kitchen Placeholder">';
                    }
                });
            }
        }
    };
};

window.renderCloudinaryVideoPlayer = function () {
    let cldURLs = [];
    const dataContainer = document.getElementsByClassName('cloudinary-data-container')
    for (const el of dataContainer) {
        let cldObj = el.dataset.cloudinary && el.dataset.cloudinary.trim().startsWith("{") ? JSON.parse(el.dataset.cloudinary) : el.dataset.cloudinary;
        let videoPlayerID = el.dataset.cloudinaryVideoPlayerId;

        if (cldObj && cldObj.video && cldObj.video.videoURL && cldObj.video.videoURL !== '' && cldObj.video.videoURL !== 'null') {
            if (cldObj.videoPlayerEnabled && typeof cloudinary !== 'undefined') {
                if (cldObj.domain !== 'res.cloudinary.com') {
                    cldObj.video.widgetOptions.privateCdn = true;
                    cldObj.video.widgetOptions.secureDistribution = cldObj.domain;
                }
                let cld = window.cldVideoPlayer.new({ cloud_name: cldObj.cloudName });
                let player = cld.videoPlayer('cld-video-player' + (videoPlayerID ? '-' + videoPlayerID : ''), cldObj.video.widgetOptions);
                player.source(cldObj.video.videoURL.publicId, {}).play();
            } else {
                cldURLs.push(cldObj.video.videoURL);
            }
        }
    };

    return cldURLs;
};

window.makeCloudinaryImagesResponsive = function () {
    const cldResponsiveImgTags = document.querySelectorAll('.cld-responsive');
    const cldEl = document.getElementsByClassName('cloudinary-data-container');
    const cloudinaryObj = cldEl[0].dataset.cloudinary;

    if (cldResponsiveImgTags.length > 0) {
        if (window.cldObj === undefined && window.cloudinary && window.cloudinary.default) {
            window.cldObj = window.cloudinary.default.Cloudinary.new({ cloud_name: cloudinaryObj.cloudName || cloudinaryObj });
        }
        window.cldObj && window.cldObj.responsive();
    }
};

window.addGalleryImageAltText = function () {
    const galleryImgs = document.querySelectorAll('[data-test="img-zoom-wrap"] img');
    if (galleryImgs.length === 0) return; 
    const productName = document.querySelector('h1.product-name') ? document.querySelector('h1.product-name').innerText : '';
    let altText = productName || '';
    galleryImgs.forEach((imgEl, i) => {
        altText += " " + ( i < 10 ? '0' : '') + (i + 1);
        imgEl.setAttribute('alt', altText);
    });
};

window.addEventListener('load', () => {
    window.addGalleryImageAltText();
});

document.addEventListener('DOMContentLoaded', () => {
    window.renderCloudinaryVideoPlayer();
    window.makeCloudinaryImagesResponsive();

    const iconNextPrev = document.querySelector('.icon-next, .icon-prev');
    if (iconNextPrev) {
        iconNextPrev.addEventListener('click', () => {
            setTimeout(() => {
                window.makeCloudinaryImagesResponsive();
            }, 0);
        });
    }
});